import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Appoinment from "../../assets/Images/about_bg.jpg";
import { Calendar, Modal } from "antd";
import Calender from "./Calender";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import Loader from "../common/Loader";
import {
  FaArrowLeft,
  FaArrowRight,
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaUser,
} from "react-icons/fa6";
import configure from "../../configure";


const Booking = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [time, setTime] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [currentFormRow, setCurrentFormRow] = useState();
  const [appModal, setAppModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [company , setcompany] = useState("");

  const [selectedDate, setSelectedDate] = useState("");
  const [isWeekendDate, setIsWeekendDate] = useState("");

  const [bookId, setBookId] = useState("");

  const [selectedSlot, setSelectedSlot] = useState("");
  const [prevDate, setPrevDate] = useState(false);

  const [selectedTimeZone, setSelectedTimeZone] = useState({
    label: "Europe/London",
    value: "Europe/London",
  });

 
   const isBooked = selectedTimeZone.value === "Europe/London";

  const toggle = () => {
    if (!appModal) {
      setCurrentFormRow(1);
      setUserName("");
      setUserEmail("")
      setUserPhone("");
      setSelectedService("");
    }
    setAppModal(!appModal);
  };

  const timeSlots = [
    { id: 1, from: "9:00 AM", to: "9:30 AM" },
    { id: 2, from: "9:30 AM", to: "10:00 AM" },
    { id: 3, from: "10:00 AM", to: "10:30 AM" },
    { id: 4, from: "10:30 AM", to: "11:00 AM" },
    { id: 5, from: "11:00 AM", to: "11:30 AM" },
    { id: 6, from: "11:30 AM", to: "12:00 PM" },
    { id: 7, from: "12:00 PM", to: "12:30 PM" },
    { id: 8, from: "12:30 PM", to: "01:00 PM" },
    { id: 9, from: "01:00 PM", to: "01:30 PM" },
    { id: 10, from: "01:30 PM", to: "02:00 PM" },
    { id: 11, from: "02:00 PM", to: "02:30 PM" },
    { id: 12, from: "02:30 PM", to: "03:00 PM" },
    { id: 13, from: "03:00 PM", to: "03:30 PM" },
    { id: 14, from: "03:30 PM", to: "04:00 PM" },
    { id: 15, from: "04:00 PM", to: "04:30 PM" },
    { id: 16, from: "04:30 PM", to: "05:00 PM" },
  ];

  const [filterTimeSlots, setFilterTimeSlots] = useState([]);

  const aryIanaTimeZones = [
    "Europe/Andorra",
    "Asia/Dubai",
    "Asia/Kabul",
    "Europe/Tirane",
    "Asia/Yerevan",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Mawson",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Cordoba",
    "America/Argentina/Salta",
    "America/Argentina/Jujuy",
    "America/Argentina/Tucuman",
    "America/Argentina/Catamarca",
    "America/Argentina/La_Rioja",
    "America/Argentina/San_Juan",
    "America/Argentina/Mendoza",
    "America/Argentina/San_Luis",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Ushuaia",
    "Pacific/Pago_Pago",
    "Europe/Vienna",
    "Australia/Lord_Howe",
    "Antarctica/Macquarie",
    "Australia/Hobart",
    "Australia/Currie",
    "Australia/Melbourne",
    "Australia/Sydney",
    "Australia/Broken_Hill",
    "Australia/Brisbane",
    "Australia/Lindeman",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Perth",
    "Australia/Eucla",
    "Asia/Baku",
    "America/Barbados",
    "Asia/Dhaka",
    "Europe/Brussels",
    "Europe/Sofia",
    "Atlantic/Bermuda",
    "Asia/Brunei",
    "America/La_Paz",
    "America/Noronha",
    "America/Belem",
    "America/Fortaleza",
    "America/Recife",
    "America/Araguaina",
    "America/Maceio",
    "America/Bahia",
    "America/Sao_Paulo",
    "America/Campo_Grande",
    "America/Cuiaba",
    "America/Santarem",
    "America/Porto_Velho",
    "America/Boa_Vista",
    "America/Manaus",
    "America/Eirunepe",
    "America/Rio_Branco",
    "America/Nassau",
    "Asia/Thimphu",
    "Europe/Minsk",
    "America/Belize",
    "America/St_Johns",
    "America/Halifax",
    "America/Glace_Bay",
    "America/Moncton",
    "America/Goose_Bay",
    "America/Blanc-Sablon",
    "America/Toronto",
    "America/Nipigon",
    "America/Thunder_Bay",
    "America/Iqaluit",
    "America/Pangnirtung",
    "America/Atikokan",
    "America/Winnipeg",
    "America/Rainy_River",
    "America/Resolute",
    "America/Rankin_Inlet",
    "America/Regina",
    "America/Swift_Current",
    "America/Edmonton",
    "America/Cambridge_Bay",
    "America/Yellowknife",
    "America/Inuvik",
    "America/Creston",
    "America/Dawson_Creek",
    "America/Fort_Nelson",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Dawson",
    "Indian/Cocos",
    "Europe/Zurich",
    "Africa/Abidjan",
    "Pacific/Rarotonga",
    "America/Santiago",
    "America/Punta_Arenas",
    "Pacific/Easter",
    "Asia/Shanghai",
    "Asia/Urumqi",
    "America/Bogota",
    "America/Costa_Rica",
    "America/Havana",
    "Atlantic/Cape_Verde",
    "America/Curacao",
    "Indian/Christmas",
    "Asia/Nicosia",
    "Asia/Famagusta",
    "Europe/Prague",
    "Europe/Berlin",
    "Europe/Copenhagen",
    "America/Santo_Domingo",
    "Africa/Algiers",
    "America/Guayaquil",
    "Pacific/Galapagos",
    "Europe/Tallinn",
    "Africa/Cairo",
    "Africa/El_Aaiun",
    "Europe/Madrid",
    "Africa/Ceuta",
    "Atlantic/Canary",
    "Europe/Helsinki",
    "Pacific/Fiji",
    "Atlantic/Stanley",
    "Pacific/Chuuk",
    "Pacific/Pohnpei",
    "Pacific/Kosrae",
    "Atlantic/Faroe",
    "Europe/Paris",
    "Europe/London",
    "Asia/Tbilisi",
    "America/Cayenne",
    "Africa/Accra",
    "Europe/Gibraltar",
    "America/Godthab",
    "America/Danmarkshavn",
    "America/Scoresbysund",
    "America/Thule",
    "Europe/Athens",
    "Atlantic/South_Georgia",
    "America/Guatemala",
    "Pacific/Guam",
    "Africa/Bissau",
    "America/Guyana",
    "Asia/Hong_Kong",
    "America/Tegucigalpa",
    "America/Port-au-Prince",
    "Europe/Budapest",
    "Asia/Jakarta",
    "Asia/Pontianak",
    "Asia/Makassar",
    "Asia/Jayapura",
    "Europe/Dublin",
    "Asia/Jerusalem",
    "Asia/Kolkata",
    "Indian/Chagos",
    "Asia/Baghdad",
    "Asia/Tehran",
    "Atlantic/Reykjavik",
    "Europe/Rome",
    "America/Jamaica",
    "Asia/Amman",
    "Asia/Tokyo",
    "Africa/Nairobi",
    "Asia/Bishkek",
    "Pacific/Tarawa",
    "Pacific/Enderbury",
    "Pacific/Kiritimati",
    "Asia/Pyongyang",
    "Asia/Seoul",
    "Asia/Almaty",
    "Asia/Qyzylorda",
    "Asia/Qostanay",
    "Asia/Aqtobe",
    "Asia/Aqtau",
    "Asia/Atyrau",
    "Asia/Oral",
    "Asia/Beirut",
    "Asia/Colombo",
    "Africa/Monrovia",
    "Europe/Vilnius",
    "Europe/Luxembourg",
    "Europe/Riga",
    "Africa/Tripoli",
    "Africa/Casablanca",
    "Europe/Monaco",
    "Europe/Chisinau",
    "Pacific/Majuro",
    "Pacific/Kwajalein",
    "Asia/Yangon",
    "Asia/Ulaanbaatar",
    "Asia/Hovd",
    "Asia/Choibalsan",
    "Asia/Macau",
    "America/Martinique",
    "Europe/Malta",
    "Indian/Mauritius",
    "Indian/Maldives",
    "America/Mexico_City",
    "America/Cancun",
    "America/Merida",
    "America/Monterrey",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Chihuahua",
    "America/Ojinaga",
    "America/Hermosillo",
    "America/Tijuana",
    "America/Bahia_Banderas",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Africa/Maputo",
    "Africa/Windhoek",
    "Pacific/Noumea",
    "Pacific/Norfolk",
    "Africa/Lagos",
    "America/Managua",
    "Europe/Amsterdam",
    "Europe/Oslo",
    "Asia/Kathmandu",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Auckland",
    "Pacific/Chatham",
    "America/Panama",
    "America/Lima",
    "Pacific/Tahiti",
    "Pacific/Marquesas",
    "Pacific/Gambier",
    "Pacific/Port_Moresby",
    "Pacific/Bougainville",
    "Asia/Manila",
    "Asia/Karachi",
    "Europe/Warsaw",
    "America/Miquelon",
    "Pacific/Pitcairn",
    "America/Puerto_Rico",
    "Asia/Gaza",
    "Asia/Hebron",
    "Europe/Lisbon",
    "Atlantic/Madeira",
    "Atlantic/Azores",
    "Pacific/Palau",
    "America/Asuncion",
    "Asia/Qatar",
    "Indian/Reunion",
    "Europe/Bucharest",
    "Europe/Belgrade",
    "Europe/Kaliningrad",
    "Europe/Moscow",
    "Europe/Simferopol",
    "Europe/Kirov",
    "Europe/Astrakhan",
    "Europe/Volgograd",
    "Europe/Saratov",
    "Europe/Ulyanovsk",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Omsk",
    "Asia/Novosibirsk",
    "Asia/Barnaul",
    "Asia/Tomsk",
    "Asia/Novokuznetsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Chita",
    "Asia/Yakutsk",
    "Asia/Khandyga",
    "Asia/Vladivostok",
    "Asia/Ust-Nera",
    "Asia/Magadan",
    "Asia/Sakhalin",
    "Asia/Srednekolymsk",
    "Asia/Kamchatka",
    "Asia/Anadyr",
    "Asia/Riyadh",
    "Pacific/Guadalcanal",
    "Indian/Mahe",
    "Africa/Khartoum",
    "Europe/Stockholm",
    "Asia/Singapore",
    "America/Paramaribo",
    "Africa/Juba",
    "Africa/Sao_Tome",
    "America/El_Salvador",
    "Asia/Damascus",
    "America/Grand_Turk",
    "Africa/Ndjamena",
    "Indian/Kerguelen",
    "Asia/Bangkok",
    "Asia/Dushanbe",
    "Pacific/Fakaofo",
    "Asia/Dili",
    "Asia/Ashgabat",
    "Africa/Tunis",
    "Pacific/Tongatapu",
    "Europe/Istanbul",
    "America/Port_of_Spain",
    "Pacific/Funafuti",
    "Asia/Taipei",
    "Europe/Kiev",
    "Europe/Uzhgorod",
    "Europe/Zaporozhye",
    "Pacific/Wake",
    "America/New_York",
    "America/Detroit",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Indiana/Indianapolis",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Vevay",
    "America/Chicago",
    "America/Indiana/Tell_City",
    "America/Indiana/Knox",
    "America/Menominee",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/North_Dakota/Beulah",
    "America/Denver",
    "America/Boise",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Juneau",
    "America/Sitka",
    "America/Metlakatla",
    "America/Yakutat",
    "America/Nome",
    "America/Adak",
    "Pacific/Honolulu",
    "America/Montevideo",
    "Asia/Samarkand",
    "Asia/Tashkent",
    "America/Caracas",
    "Asia/Ho_Chi_Minh",
    "Pacific/Efate",
    "Pacific/Wallis",
    "Pacific/Apia",
    "Africa/Johannesburg",
  ];

  const timeZonesWithLabelValue = aryIanaTimeZones.map((timeZone) => ({
    label: timeZone,
    value: timeZone,
  }));

  useEffect(() => {
    if (window.location.hash == "#booknow") {
        toggle()
    }
  }, []);
  

  const handleDateChange = async (newDate) => {
    const currentDate = moment(new Date()).format("YYYY-MM-DD");
    const sDate = moment(newDate.$d).format("YYYY-MM-DD");
    if (sDate < currentDate) {
      swal({
        text: "Please select a date from today onwards.",
        icon: "warning",
      });
      setPrevDate(true);
    } else if (sDate >= currentDate) {
      setSelectedDate(moment(newDate.$d).format("YYYY-MM-DD"));
      setIsWeekendDate(newDate.$d);
      setPrevDate(false);
      const formData = new FormData();
      formData.append("date", moment(newDate.$d).format("YYYY-MM-DD"));
      try {
        const response = await axios.post(

          `${configure.appUrl}checkAvailability`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response) {
          const timeId = response.data.data.map((ob) => ob.time_id);
          const filteredTimeSlots = timeSlots.filter(
            (slot) => !timeId.includes(slot.id)
          );
          setFilterTimeSlots(filteredTimeSlots);
        }
      } catch (error) {
        // console.log(error);
      }
    }
  };

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot.id);
    setTime(`${slot.from}-${slot.to}`);
  };

  const handleNextButtonClick = () => {
    setCurrentFormRow(currentFormRow + 1);
  };

  // Api Integration
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(userEmail)) {
      swal("", "Invalid Email Address!", "warning");
      return;
    }

    if (userPhone.length < 10) {
      swal("", "Invalid phone number!", "warning");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("name", userName);
    formData.append("email", userEmail);
    formData.append("phone", userPhone);
    formData.append("services", selectedService);
    formData.append("type", 25);
    formData.append("enquiry_type", "meeting");
    formData.append("company" , company);


    try {
      const response = await axios.post(
     
        `https://api.zithas.com/api/addBookings`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

        if (response.data.success) {
          setLoading(false);
          setBookId(response.data.data);
          handleNextButtonClick();
          // console.log("data", formData)
          // console.log("resp", response.status);
        }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  const isWeekend = (date) => {
    const dayOfWeek = moment(date).day();
    return dayOfWeek === 6 || dayOfWeek === 0;
  };

  const loadDate = () => {
    const currentDate = new Date();
    isWeekend(currentDate);
    handleDateChange(currentDate);
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "instant",
    });

    loadDate();
    setSelectedDate(moment().format("YYYY-MM-DD"));
  }, []);

  // main slot booking
  const handleSubmitAppoinment = async (e) => {
    e.preventDefault();

    if (selectedSlot !== null && selectedSlot !== "") {
      setLoading(true);

      const formData = new FormData();
      formData.append("date", selectedDate);
      formData.append("time", time);
      formData.append("time_id", selectedSlot);
      formData.append("timezone", selectedTimeZone.value);
      formData.append("book_id", bookId);
      try {
        const response = await axios.post(
          `https://api.zithas.com/api/updateSlot`,
          

          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.error) {
          swal("", `Something went wrong!`, "error");
          return;
        }

          if (response.data.success) {
            setTimeout(() => {
              // swal(
              //   "",
              //   `Meeting link created and sent to  ${userEmail}`,
              //   "success"
              // ).then(() => {
                setSelectedDate(moment().format("YYYY-MM-DD"));
                setAppModal(false);
                setSelectedSlot("");
                navigate("/construction/thankyou");
              // });
            }, 1000);
          }
      } catch (error) {
        swal({
          title: `Something went wrong`,
          text: "Please try again",
          icon: "warning",
        });
        // console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      swal({
        text: "Please Select any time slot",
        icon: "warning",
      });
    }
  };

  function parseTimeString(timeStr) {
    // Assuming timeStr is in "hh:mm A" format
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");

    hours = parseInt(hours);
    minutes = parseInt(minutes);

    if (period === "PM" && hours < 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    return date;
  }


  const todaySlots = filterTimeSlots.filter((slot) => {
    const currentLondonTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/London",
    });
    let londonTime = new Date(currentLondonTime);
    londonTime.setMinutes(londonTime.getMinutes() + 30);
    const slotTime = parseTimeString(slot.from);
    return londonTime < slotTime;
  });

  return (
    <>
      {loading && <Loader />}

      <button
        onClick={toggle}
        className="button btn-red bg-white text-dark ms-md-3 mt-md-0 mt-3 shadow m-0  mb-2"
        style={{ cursor: "pointer" }}
      >
        Make an Appointment
        <i className="fa-solid fa-arrow-right-long ps-2"></i>
      </button>

      <Modal
        open={appModal}
        onCancel={() => toggle()}
        size="lg"
        width={1100}
        centered
        className="AppointmentModal "
        footer={null}
      >
        <div className="container fade-left-container">
          {currentFormRow === 1 && (
            <div className="row d-flex align-items-center">
              <div className="col-md-6 d-md-block d-none">
                <div className=" pe-md-4">
                  <img
                    src={Appoinment}
                    alt="Appoinment"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-6 px-mbd-0">
                <div className="py-5">
                  <div
                    className="  wow bounceIn bounceIn-mbd"
                    data-wow-delay="0.5s"
                    style={{
                      visibility: "visible",
                      animationDelay: "0.5s",
                      animationName: "bounceIn",
                    }}
                  >
                    <h4 className="mb-3">Make an Appointment</h4>

                    <div>
                      <p
                        className="register_success_box"
                        style={{ display: "none" }}
                      >
                        We received your message and you'll hear from us soon.
                        Thank You!
                      </p>

                      <form
                        onSubmit={handleSubmit}
                        id="register-form"
                        className="register-form register"
                      >
                        <div className="input-icon mb-3">
                          <i>
                            <FaUser />
                          </i>
                          <input
                            className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                            required
                            name="register_names"
                            placeholder="Name*"
                            type="text"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                          />
                        </div>

                        <div className="input-icon mb-3">
                          <i>
                            <FaEnvelope />
                          </i>
                          <input
                            className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                            required
                            name="register_email"
                            placeholder="Email Adress*"
                            type="email"
                            value={userEmail}
                            onChange={(e) =>
                              setUserEmail(e.target.value.toLowerCase())
                            }
                          />
                        </div>
                        <div className="input-icon mb-3">
                          <i>
                            <FaPhone />
                          </i>
                          <input
                            className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                            required
                            name="register_email"
                            placeholder="Phone Number*"
                            type="number"
                            value={userPhone}
                            onChange={(e) => {
                              setUserPhone(e.target.value.slice(0, 12));
                            }}
                          />
                        </div>
                        <div className="input-icon mb-3">
                          <i>
                            <FaBuilding />
                          </i>
                          <input
                            className="form-control shadow-sm py-2 ps-5 pe-3 fs-6 lh-lg"
                            required
                            name="register_email"
                            placeholder="Company Name*"
                            type="text"
                            value={company}
                            onChange={(e) => {
                              setcompany(e.target.value)
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <select
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                            className="form-select shadow-sm py-2 ps-3 pe-5 fs-6 lh-lg"
                            required
                          >
                            <option value="">Select Service</option>
                            <option value="47">Website Development</option>
                            <option value="48">Mobile Application Development</option>
                            <option value="49">Document Management System</option>
                          </select>
                        </div>

                        <button
                          id="modalSubmit"
                          className="button btn-red mt-3 w-100"
                          type="submit"
                          // onClick={handleNextButtonClick()}
                        >
                          Submit & Next
                          <FaArrowRight className="ms-3" />
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center text-muted">
                Rest assured, your data is safe with us. We strictly adhere to
                GDPR compliance standards.
              </div>
            </div>
          )}

          {currentFormRow === 2 && (
            <div>
              <form onSubmit={handleSubmitAppoinment}>
                <div className="">
                  <button
                    className="btn btn-dark py-2  "
                    type="button"
                    onClick={() => setCurrentFormRow(1)}
                  >
                    <FaArrowLeft className="me-2" /> Back
                  </button>
                </div>

                <div>
                  <div className="d-flex justify-content-between  align-items-center py-0">
                    <div className=""></div>
                  </div>
                </div>
                <div className="row pb-2">
                  <div className="col-md-6 ps-0">
                    <Calender
                      selectedDate={selectedDate}
                      handleDateChange={handleDateChange}
                      value={selectedDate}
                    />
                    <div className="row d-flex align-items-center justify-content-center pb-mbd-2">
                      <div className="col-md-12 ps-4">
                        <p className="fs-6 bg-transparent border-0 Timezone-width text-dark mb-0">
                          Timezone
                        </p>
                        <select
                          defaultValue="Europe/London"
                          className="bg-transparent form-control p-0 text-red border-0 Timezone-width"
                          value={selectedTimeZone.value}
                          onChange={(e) =>
                            setSelectedTimeZone({
                              value: e.target.value,
                              label: e.target.value,
                            })
                          }
                          // addition
                          disabled = {isBooked}
                        >
                          <option value={"Europe/London"} disabled={isBooked}>Europe/London</option>
                          {timeZonesWithLabelValue.map((ob, index) => (
                            <option key={index} value={ob.value}>
                              {ob.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-md-0 mt-5">
                    <div className="text-end">
                      {!prevDate && !isWeekend(isWeekendDate) && (
                        <button
                          type="submit"
                          className="button btn-red "
                          style={{ cursor: "pointer" }}
                        >
                          Book Appointment
                        </button>
                      )}
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div
                        className={` ps-0  pt-2 ${
                          prevDate || isWeekend(selectedDate)
                            ? "d-flex align-items-center"
                            : ""
                        }`}
                      >
                        <div
                          className={`bg-white shadow-sm  p-4 ${
                            prevDate || isWeekend(selectedDate)
                              ? ""
                              : "border border-1 shadow-sm"
                          }`}
                        >
                          {
                            !isWeekend(selectedDate) &&
                              !prevDate &&
                              filterTimeSlots.length !== 0 && (
                                <h4 className=" mb-3 ">Select a time slot</h4>
                              )
                            // )
                          }
                          {filterTimeSlots.length !== 0 &&
                            !isWeekend(isWeekendDate) &&
                            !prevDate && (
                              <div className="row ">
                                {selectedDate === moment().format("YYYY-MM-DD")
                                  ? todaySlots.map((slot, index) => {
                                      return (
                                        <div
                                          key={slot.id}
                                          className="col-md-6 mb-2"
                                        >
                                          <div
                                            className={`time-slot py-2 border text-center ${
                                              selectedSlot === slot.id
                                                ? "selected-timeSlot"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              handleSlotClick(slot)
                                            }
                                          >
                                            {`${slot.from} - ${slot.to}`}
                                          </div>
                                        </div>
                                      );
                                    })
                                  : filterTimeSlots.map((slot, index) => (
                                      <div
                                        key={slot.id}
                                        className="col-md-6 mb-2"
                                      >
                                        <div
                                          className={`time-slot py-2 border text-center ${
                                            selectedSlot === slot.id
                                              ? "selected-timeSlot"
                                              : ""
                                          }`}
                                          onClick={() => handleSlotClick(slot)}
                                        >
                                          {`${slot.from} - ${slot.to}`}
                                        </div>
                                      </div>
                                    ))}
                                {}
                              </div>
                            )}
                          {
                          selectedDate === moment().format("YYYY-MM-DD") ? (
                            // prevDate || todaySlots.length == 0 ? (
                            //   <div className="row">
                            //     <div className="col-12">
                            //       <div
                            //         className="alert alert-danger"
                            //         role="alert"
                            //       >
                            //         <h4>There are no slots available.</h4>
                            //       </div>
                            //     </div>
                            //   </div>
                            // ) : (
                            //   ""
                            // )
                            todaySlots.length === 0 || prevDate ? (
                              <div className="row">
                                <div className="col-12">
                                  <div className="alert alert-danger" role="alert">
                                    <h4>There are no slots available.</h4>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )

                          ) : filterTimeSlots.length == 0 ||
                            prevDate ||
                            isWeekend(selectedDate) ? (
                            <div className="row">
                              <div className="col-12">
                                <div
                                  className="alert alert-danger"
                                  role="alert"
                                >
                                  <h4>There are no slots available.</h4>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Booking;
